import { apiRequest } from '@services/apiClient';
import languagesEndpoints from '@services/languages/languagesEndpoints';

export function createLanguageRequest(payload) {
  return apiRequest(languagesEndpoints.base, {
    method: 'POST',
    body: payload
  });
}

export function listLanguagesRequest() {
  return apiRequest(languagesEndpoints.base);
}

export function getLanguageByIdRequest(id) {
  return apiRequest(languagesEndpoints.byId(id));
}

export function updateLanguageRequest(id, payload) {
  return apiRequest(languagesEndpoints.byId(id), {
    method: 'PUT',
    body: payload
  });
}

export function deleteLanguageRequest(id) {
  return apiRequest(languagesEndpoints.byId(id), {
    method: 'DELETE'
  });
}
